<template>
    <div class="container">
        <div v-if="dados">
            
            <div>

                <config-main-title>
                    {{ dados.title }}
                    <template v-slot:right>
                        <button type="button" class="btn ml-2 my-3 btn-outline-secondary" @click="editar()" v-if="dados.custom">
                          <i class="fa-solid fa-gear"></i>
                        </button>
                        <button type="button" class="btn ml-2 my-3 btn-outline-secondary" @click="acessos()">
                          <i class="fas fa-user-lock"></i>
                        </button>
                    </template>
                </config-main-title>

                <div class="card dashcard mb-0 w3-animate-opacity " v-if="dados && fonte && inputs && inputs.length">
                    <div class="card-body py-1">
                        <parametros-relatorio ref="parametros" v-model="inputs" @carregar="obter_dados" v-if="inputs" :is_dashboard="true">
                            <button class="btn btn-outline-secondary my-3 mr-2" type="button" @click="obter_dados($refs.parametros.obter_parametros())" 
                                :disabled="$store.state.loading" 
                                data-toggle="tooltip" data-placement="top" title="Buscar" id="refresh-button">
                                <i class="fas fa-sync-alt"></i>
                            </button>
                        </parametros-relatorio>
                    </div>
                </div>

                <div class="progress mt-1 mb-3">
                    <div class="indeterminate" v-if="$store.state.loading"></div>
                    <div class="determinate" v-else></div>
                </div>
                
                <div class="form-row mb-3" v-if="dados && fonte">
                    <div class="col col-12 mb-2" :class="'col-md-' + item.col_width" v-for="(item, idx) in dados.dashboard_items" :key="idx">
                        <div v-if="item.dashboard_item_type_id == 4">
                            <az-break-title :title="item.title" />
                        </div>
                        <div class="card carde w3-animate-opacity mb-0" style="height: 100%;" :class="fullscreens[idx] ? 'panel-fullscreen' : ''" v-else>
                            <div class="card-header d-flex justify-content-between" :class="item.config.color ? 'text-white bg-' + item.config.color : ''">
                                <div class="text-nowrap text-truncate">
                                    {{ item.title }} 
                                    <a href="#" @click.prevent="exibir_info(item)" v-if="item.info" class="card-link text-white ml-2">
                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <div class="d-flex">
                                    <router-link :to="{ name: 'relatorio', params: { id: item.config.query_id, dash_id: dados.id, filtros: item.config.filtros } }" class="card-link" title="Ver Relatório" v-if="dados.custom">
                                        <h5 class="mb-0">
                                            <i class="fa-solid fa-file-lines text-white"></i>
                                        </h5>
                                    </router-link>

                                    <a href="#" class="btn btn-light btn-sm ml-3" @click.prevent="toggle_fullscreen(idx)" 
                                        v-if="item.dashboard_item_type_id != 2">
                                        <i class="fas fa-compress-alt" v-if="fullscreens[idx]"></i>
                                        <i class="fas fa-expand-alt" v-else></i>    
                                    </a>
                                </div>
                            </div>
                            <!-- Relatório de Tabela -->
                            <template v-if="item.dashboard_item_type_id == 1">
                                <relatorio-tabela 
                                    :config="item.config"
                                    :relatorio="fonte['r' + item.config.query_id].data" 
                                    v-if="fonte['r' + item.config.query_id].data.result"/> 
                                <div class="card-body text-center" v-else>
                                    <i class="fas fa-table fa-7x my-3"></i>
                                    <div class="lead">Sem Conteúdo</div>
                                </div>
                            </template>
                            <div class="card-body" v-else-if="item.dashboard_item_type_id == 2">
                                <indicador-unico :relatorio="fonte['r' + item.config.query_id].data" :config="item.config" :query="item.query"/>
                            </div>
                            <div class="card-body" v-else-if="item.dashboard_item_type_id == 3">
                                <template v-if="graficos[idx] && graficos[idx].type == 'value'">
                                    <table class="table">
                                        <tbody>
                                        <tr v-for="(label, ilx) in graficos[idx].basicData.labels" :key="ilx">
                                            <td>{{ label }}</td>
                                            <td>{{ graficos[idx].basicData.datasets[0].data[ilx].toLocaleString() }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </template>
                                <Chart v-else-if="graficos[idx]"
                                    :type="graficos[idx].type" 
                                    :data="graficos[idx].basicData" 
                                    :options="graficos[idx].options" />
                                <div v-else class="text-center">
                                    <i class="fas fa-chart-bar fa-7x my-3"></i>
                                    <div class="lead">Sem Conteúdo</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="1 == 0">
                <pre class="alert alert-info">{{ fullscreens }}</pre>
                <pre class="alert alert-info">{{ dados }}</pre>
            </div>

        </div>

        <az-loading v-else-if="!dados" msg="Carregando..." />

        <edicao-acessos ref="acessos" />

        <!-- Modal Informação -->
        <div class="modal fade" id="infoItemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="info">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
                            {{ info.title }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            {{ info.info }}
                        </div>
                        <pre v-if="false">{{ info }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" data-dismiss="modal" v-if="$store.state.user.id_usuario == 1 && info.query && info.query.id" @click="abrir_relatorio(info)">
                            Detalhe
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue';
import RelatorioTabela from './shared/RelatorioTabela.vue';
import IndicadorUnico from './shared/IndicadorUnico.vue';
import ParametrosRelatorio from './shared/ParametrosRelatorio.vue';
import AzBreakTitle from '../util/AzBreakTitle.vue';
import AzLoading from '../util/AzLoading.vue';
import EdicaoAcessos from '../cadastros/shared/EdicaoAcessos.vue';

export default {
    data() { 
        return { 
            dados: null, 
            fonte: null, 
            parms: {}, 
            inputs: [],
            refreshing: false, 
            graficos: [],
            fullscreens: [],
            info: null, 
        };
    },

    props: ['id'], 

    components: { 
        ConfigMainTitle, 
        RelatorioTabela, 
        IndicadorUnico,
        ParametrosRelatorio,
        AzBreakTitle,
        AzLoading,
        EdicaoAcessos
    },

    computed: { 
        queries: function() { 
            if( !this.dados ) 
                return [];

            return _.uniq(this.dados.dashboard_items.map(item => item.config.query_id));
        }, 
    },

    methods: { 
        editar () { 
            this.$router.push({ path: "/dashboard/editor/" + this.dados.id });
        },

        abrir_relatorio (item) { 
            if ( item && item.query && item.query.id ) { 
                $('.modal').modal('hide');

                this.$nextTick(() => { 
                    this.$router.push({ path: "/relatorio/" + item.query.id });

                    //console.log('item', item);
                    //this.$router.push({ name: "relatorio", params: { id: item.query.id } });                    
                });
            }
        },

        exibir_info (item) { 
            this.info = _.cloneDeep(item);

            $('#infoItemModal').modal('show');
        },

        acessos() { 
            this.$refs.acessos.abrir('App\\Dashboard', this.id);
        },

        toggle_fullscreen (idx) { 
            this.fullscreens[idx] = !this.fullscreens[idx];
            this.$forceUpdate();
        },

        obter_parametros () { 
        
            if ( !this.fonte || !this.dados || !this.dados.config || !this.dados.config.parms || !this.dados.config.parms.length )
                return null;

            if ( this.dados.custom ) { 

                let listaParms = _.cloneDeep(
                    this.dados.config.parms.map(item => { 

                        let parm;

                        if ( item.parm == ':periodo' ) { 

                            _.find(this.fonte, relatorio => { 
                                if ( !relatorio.data || !relatorio.data.inputs )
                                    return;

                                parm = relatorio.data.inputs.find(input => { 
                                    return input.id.slice(0, 7) == 'periodo' && input.type == 'per-date';
                                });

                                return parm ? true : false;
                            });

                            return parm;

                        } else { 

                            _.find(this.fonte, relatorio => { 
                                
                                if ( !relatorio.data || !relatorio.data.inputs )
                                    return;

                                parm = relatorio.data.inputs.find(input => { 
                                    return input.name == item.parm;
                                });

                                return parm ? true : false;
                            });

                            parm.id = '@' + parm.name;

                            return parm;

                        }

                    })
                );

                listaParms = listaParms.filter(item => item);

                return listaParms;

            } else { 

                return _.cloneDeep(
                    this.dados.config.parms.map(item => { 
                        return this.fonte['r' + item.query_id] 
                            && this.fonte['r' + item.query_id].data.inputs.find(inp => inp.id == item.parm.substr(1));
                    })
                );

            }

        },

        get_grafico (config) { 
            if ( this.fonte['r' + config.query_id] 
                && this.fonte['r' + config.query_id].data
                && this.fonte['r' + config.query_id].data.result
                && this.fonte['r' + config.query_id].data.result.graphs ) { 

                let grafico = _.cloneDeep(
                    this.fonte['r' + config.query_id].data.result.graphs.find(item => item.title == config.grafico)
                );
                
                return grafico;

            } else { 
                
                return null;
            }
        },

        tratar_graficos () { 

            this.fullscreens = [];
            this.graficos = [];

            this.dados.dashboard_items.forEach(() => { 
                    this.graficos.push(null);
                    this.fullscreens.push(false);
                });

            //.filter((item, idx) => item.dashboard_item_type_id == 3)

            this.dados.dashboard_items
                .forEach((item, idx) => { 
                    if ( item.dashboard_item_type_id == 3 ) { 
                        this.graficos[idx] = this.get_grafico(item.config);
                        item.grafico = this.get_grafico(item.config);
                    }
                });
        },

        load() { 
            this.$util.load(this, { 
                service: 'dashboards',
                parms: { 
                    id: this.id,
                    ...this.inputs,
                },
                redir_api: true, 
                loadTo: dados => { 
                    this.dados = dados;

                    // Breadcrumb 
                    let breadcrumb = [
                            { name: "Relatórios", path: "/relatorios" }
                        ];
                    
                    breadcrumb.push({
                            name: dados.title,
                            path: "/dashboard/" + this.id
                        });

                    this.$store.commit("setBreadcrumb", breadcrumb);
                    //

                    this.obter_dados();
                },
                final: () => { 
                    this.$store.commit('loading', false);
                }
            });
        },

        obter_dados (inputs = null) { 
            this.$store.commit("loading", true);

            if ( inputs )
                this.refreshing = true;

            let query = { q: [] };
            let parms = inputs ? inputs : {};

            this.queries.filter(item => item)
                .forEach(element => {
                    query.q.push({ 
                        name: "relatorios.show",
                        parms: { 
                            id: element, 
                            ...parms, 
                            dash_custom: this.dados.custom,
                            dash_id: this.dados.id
                        },
                        id: 'r' + element
                    });
                });

            const base = this.axios.defaults.baseURL;
            const redir = ( base.substr(0,5) == 'https' 
                ? 'https://api-relatorio.klingo.app/api' 
                : ''
            );

            this.axios.post(redir + "/aql?a=dashboard.relatorio.show", query)
                .then(res => {
                    this.fonte = res.data;

                    this.tratar_graficos ();

                    if ( !inputs )
                        this.inputs = this.obter_parametros();
                })
                .finally(() => { 
                    this.$store.commit("loading", false);
                });

        
        },

    },

    mounted() { 
        this.load();
    }
}
</script>

<style scoped>
.panel-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
</style>